import { Alert, Stack, Typography } from '@mui/material'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import GetPrinters from './GetPrinters'

const CheckConfiguration = () => {
  const initStarted = useRef<boolean>(false)
  const [isBrowserSupported, setIsBrowserSupported] = useState<
    boolean | undefined
  >()
  const [isFrameworkInstalled, setIsFrameworkInstalled] = useState<
    boolean | undefined
  >()
  const [isWebServicePresent, setIsWebServicePresent] = useState<
    boolean | undefined
  >()
  const [initializationComplete, setInitializationComplete] = useState(false)

  const checkConfig = useCallback(async () => {
    try {
      const result = window.dymo.label.framework.checkEnvironment()
      result.isBrowserSupported
        ? setIsBrowserSupported(true)
        : setIsBrowserSupported(false)
      result.isFrameworkInstalled
        ? setIsFrameworkInstalled(true)
        : setIsFrameworkInstalled(false)
      result.isWebServicePresent
        ? setIsWebServicePresent(true)
        : setIsWebServicePresent(false)
    } catch (e) {
      alert((e as any).message || e)
    }
  }, [])

  useEffect(() => {
    if (!initStarted.current && window.dymo.label.framework.init) {
      initStarted.current = true
      window.dymo.label.framework.init(() => setInitializationComplete(true))
      checkConfig()
    }
  }, [checkConfig])

  const configurationIsCorrect = useMemo(
    () =>
      isBrowserSupported === true &&
      isFrameworkInstalled === true &&
      isWebServicePresent === true &&
      initializationComplete,
    [
      isBrowserSupported,
      isFrameworkInstalled,
      isWebServicePresent,
      initializationComplete
    ]
  )

  return (
    <Stack alignItems="flex-start" justifyContent="flex-start" spacing={2}>
      {isBrowserSupported === undefined &&
        isFrameworkInstalled === undefined &&
        isWebServicePresent === undefined && (
          <Typography>Checking Configuration...</Typography>
        )}
      {isBrowserSupported === false && (
        <Alert severity="error">Browser not supported</Alert>
      )}
      {isFrameworkInstalled === false && (
        <Alert severity="error">Framework not installed</Alert>
      )}
      {isWebServicePresent === false && (
        <Alert severity="error">Web service not present</Alert>
      )}
      {configurationIsCorrect && <GetPrinters />}
    </Stack>
  )
}

export default CheckConfiguration
